/**
 * Highcharts `chart.zooming` for a history chart.
 * Desktop (no `shared`): no drag-zoom — the mouse drags to PAN and the navigator does the rest.
 * Mobile (`shared.pinch`): two-finger pinch zooms / pans the x axis; one finger still scrolls the
 * page (singleTouch off). The "Reset zoom" button is hidden — the sticky All button does that.
 */
export function zoomingFor(shared) {
    if (!shared || !shared.pinch) return { type: undefined };
    // mouseWheel off: with zooming.type set, Highcharts 12 would otherwise zoom on wheel and hijack page scrolling.
    return { type: 'x', pinchType: 'x', singleTouch: false, mouseWheel: { enabled: false }, resetButton: { theme: { style: { display: 'none' } } } };
}

// Two fingers can't move perfectly parallel, so Highcharts reads every two-finger PAN as a slight
// zoom. Gesture rule: until the finger distance has changed by PINCH_DEAD_ZONE since the fingers
// touched down, every frame is forced to a pure pan; once it has, the gesture is a zoom until the
// fingers lift. Hooked on Highcharts' `transform` event (fires before the maths, `to` mutable).
export const PINCH_DEAD_ZONE = 0.2;

export function pinchDeadZoneHandler(params) {
    const chart = this;
    if (!params || (params.trigger !== 'touchmove' && params.trigger !== 'touchend')) return;
    const { from, to } = params;
    const down = chart.pointer && chart.pointer.pinchDown;
    if (!from || !to || !down || down.length < 2) { chart.__pinchGesture = null; return; }
    const startWidth = Math.abs(down[1].chartX - down[0].chartX) || 1;
    let g = chart.__pinchGesture;
    if (!g || g.startWidth !== startWidth) g = chart.__pinchGesture = { startWidth, mode: null }; // new gesture
    if (g.mode === null && Math.abs(Math.abs(to.width) / startWidth - 1) >= PINCH_DEAD_ZONE) g.mode = 'zoom';
    if (g.mode !== 'zoom' && typeof from.width === 'number' && typeof to.width === 'number') {
        const center = (to.x || 0) + to.width / 2;
        to.width = from.width;                 // same spread as last frame → scale 1 → pan
        to.x = center - from.width / 2;        // keep the fingers' midpoint so the pan distance is preserved
    }
    if (params.trigger === 'touchend') chart.__pinchGesture = null;
}

let installed = false;
/** Install the dead zone once on the Highcharts Chart class (no-op without touch charts). */
export function installPinchDeadZone(Highcharts) {
    if (installed || !Highcharts || !Highcharts.addEvent || !Highcharts.Chart) return;
    Highcharts.addEvent(Highcharts.Chart, 'transform', pinchDeadZoneHandler);
    installed = true;
}
